// initialize ajax search on search page, it has #search-result element

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector('#search-result')) {
    const locale = document.querySelector('[data-locale]').dataset.locale;
    const searchParams = new URLSearchParams(window.location.search);
    const keyword = searchParams.get('keyword');
    const search = searchParams.get('search');
    const searchKeyword = keyword ?? search;

    document.querySelectorAll('input[name="keyword"]').forEach((el) => {
      el.value = searchKeyword;
    });
    // some cached page still using name=search
    document.querySelectorAll('input[name="search"]').forEach((el) => {
      el.value = searchKeyword;
    });

    htmx.ajax('GET', `/ajax_search/search?keyword=${searchKeyword}&hl=${locale}`, { target: '#search-result', swap: 'outerHTML' }, function(data) {

    });
  }
});

document.addEventListener('htmx:afterSwap', (event) => {
  const el = event.detail.elt;

  if (el.id === 'search-result') {
    let total = 0;
    el.querySelectorAll('.search-container[data-search-type]').forEach((searchEl) => {
      const count = searchEl.dataset.searchFound ?? 0;
      const type = searchEl.dataset.searchType;
      const tabValueEl = document.querySelector(`.nav-tabs [data-search-type="${type}"] [data-search-found]`);
      if (tabValueEl) {
        tabValueEl.innerHTML = parseInt(count);
      }
      total += parseInt(count);
    });

    const foundTotalEl = document.querySelector('[data-search-total-found]');
    if (foundTotalEl) {
      foundTotalEl.innerHTML = total;
    }
  }
});